import { AttemptResult } from '../domain'
export { AttemptResult } from '../domain'

export interface ExamResult {
  id: string
  score: {
    min: number
    max: number
    raw: number
    percent: number
  }
  attemptCount: number
  passingScore: number
  result: AttemptResult
  durationSeconds: number
  timestamp: Date
}

export type RemoteStateQueryPhase = 'none' | 'loading' | 'loaded' | 'error';

export const ExamResultsQuerySymbol = Symbol.for('ExamResultsQuery')

export interface ExamResultsQuery {
  findExam(id: string): ExamResult | false
  examResults: ExamResult[]
  remotePhase: RemoteStateQueryPhase;
}
